/* © CNES */
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import { useContext, useMemo, useRef, useState } from 'react';
import Floater from 'react-floater';
import { useNavigate } from 'react-router-dom';
import { authenticationAPI } from '../../../api/authentication/AuthenticateAPI';
import { ConfigContext } from '../../../context/ConfigContext';
import {
  StartGuidContent,
  startGuidStyle,
} from '../../shared/startGuidContent/StartGuidContent';
import './LoginContainer.scss';

/**
 * Login Container to display login component in application header.
 * @returns LoginContainer Element.
 */
export const LoginContainer = () => {
  const context = useContext(ConfigContext);
  const navigate = useNavigate();
  const isAuthDisabled =
    process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test';
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const menu = useRef<Menu>(null);

  /**
   * profile Menu Items for user login options.
   */
  const profileMenu = useMemo(() => {
    const profileMenuItems: MenuItem[] = [
      {
        label: 'My Profile',
        icon: 'pi pi-user',
        command: () => {
          navigate('/MyInformation');
        },
      },
      {
        label: 'Log-Out',
        icon: 'pi pi-times',
        command: () => authenticationAPI.logout(),
      },
    ];
    return profileMenuItems;
  }, [navigate]);

  const loginContainer = context.userLoggedIn?.name ? (
    <div aria-label="LoggedInContainer" className="LoggedInContainer">
      <Menu
        model={profileMenu}
        popup
        ref={menu}
        onShow={() => {
          setIsMenuOpen(!isMenuOpen);
        }}
        onHide={() => {
          setIsMenuOpen(!isMenuOpen);
        }}
      />
      <Button
        className="LoggedInButton"
        label={context.userLoggedIn.name}
        icon={`pi ${isMenuOpen ? 'pi-chevron-up' : 'pi-chevron-down'}`}
        onClick={(e: React.MouseEvent) => menu.current!.toggle(e)}
        iconPos="right"
      />
    </div>
  ) : (
    <div aria-label="LoginContainer" className="LoginContainer">
      <Button
        className="LoginButton p-button-text"
        role="button"
        label="Log In"
        onClick={() => authenticationAPI.login()}
        disabled={isAuthDisabled}
      />
    </div>
  );

  return (
    <>
      <Floater
        open={context.isGetStarted}
        content={
          <StartGuidContent
            title="Login"
            body="Login to manage your filters, download and process from millions of products"
            icon="person.png"
          />
        }
        placement="bottom-end"
        target={'.loginFloater'}
        offset={-5}
        styles={{
          ...startGuidStyle,
          ...{
            container: {
              backgroundColor: '#113268',
              borderRadius: 5,
              color: '#fff',
              filter: 'none',
              minHeight: 'none',
              padding: 15,
              minWidth: 250,
            },
          },
        }}
      />
      <div className="loginFloater">{loginContainer}</div>
    </>
  );
};
